/* eslint-disable no-new */
/* Libraries */
import Vue from 'vue'
import objectFitImages from 'object-fit-images'
import 'lazysizes/plugins/respimg/ls.respimg'
import 'lazysizes/plugins/bgset/ls.bgset.min.js'
import 'lazysizes'

/* Mixins */
import navigation from './mixins/navigation'
import filtering from './mixins/filtering'
import sproutForms from './mixins/sprout-forms'

/* Components */
import TestimonialSlider from './components/TestimonialSlider'
import VueRellax from 'vue-rellax'

/* Modules */
import './modules/keyboard-focus'
import skipNavigation from './modules/skip-navigation'
import accordions from './modules/accordions'
import adminClipboardTooltips from './modules/admin-tooltips'

/* Intial setup can be done here before Vue instantiation */
const siteWrapper = document.querySelector('.js-siteWrapper')
Vue.use(VueRellax)

/* Instance */
new Vue({

    el: siteWrapper,

    components: {
        TestimonialSlider,
    },

    mixins: [navigation, filtering, sproutForms],

    mounted () {
        objectFitImages()
        accordions()
        adminClipboardTooltips()
    },

    methods: {
        skipNavigation,
    },

})
